
const pageTextConfig = {
    addNewGigPageTitle: "Add New Gig",
    
    multiPageFormPageList: {
      withPaymentPage: [
        {
         pageNumber: 1,
         pageTitle: "Listing Details", 
        },
        {
          pageNumber: 2,
          pageTitle: "Payments Setup", 
        },
        {
          pageNumber: 3,
          pageTitle: "Agreement", 
        }, 
      ],
      withoutPaymentPage: [
        {
         pageNumber: 1,
         pageTitle: "Listing Details", 
        },
        {
          pageNumber: 2,
          pageTitle: "Agreement", 
        }, 
      ]
    }
}

export default pageTextConfig;